import { Avatar, CircularProgress } from "@mui/material";
import React from "react";

const AvatarBadge = ({ name, picture, isLoading, ...props }) => {
    const getNameInitials = () => {
        if (!name) return null;
        const [firstName, lastName] = name.split(" ");
        return `${firstName ? firstName.charAt(0) : ""}${lastName ? lastName.charAt(0) : ""}`;
    };

    const stringToColor = (string) => {
        if (!string) return "#303030";
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = "#";

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.substr(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    };

    return (
        <Avatar alt={name} src={picture} sx={{ bgcolor: stringToColor(name) }} {...props}>
            {isLoading ? <CircularProgress size={10} /> : getNameInitials(name)}
        </Avatar>
    );
};

export default AvatarBadge;
